import { Button, pxToRem, breakpoints, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  border-bottom: ${pxToRem(1)} solid ${theme.semantic.border.default};
`;
const StyledButton = styled(Button).attrs(() => ({
    type: 'button',
    appearance: 'ghost',
})) `
  color: ${theme.swatches.gray[700]};
  align-items: center;
  padding: 0;
  margin-right: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.md};

  &:disabled {
    color: ${theme.semantic.foreground.secondary};
  }
`;
export const BackWrapper = styled.div `
  color: ${theme.semantic.foreground.secondary};
  display: flex;
  flex-direction: row;
  align-items: center;

  ${breakpoints.desktop} {
    display: none;
  }
`;
export const BackCrumb = styled(StyledButton) `
  color: ${theme.swatches.gray[700]};

  &:focus-visible,
  &:hover {
    color: ${theme.semantic.foreground.secondary};
  }
`;
export const Crumb = styled(StyledButton) `
  ${breakpoints.mobile} {
    display: none;
  }
`;
